import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * CategoryCards – e.g. Professional / Organizational / Personal browse cards.
 */
const CategoryCards = ({ label, gradient, heading, items = [], paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, fontFamily, fontWeight = 700, componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 4,
            paddingBottom: paddingBottom || 4,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 1000, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), heading && (_jsx(Typography, { variant: "h5", sx: {
                        mb: 3,
                        fontFamily: fontFamily || undefined,
                        fontWeight: Number(fontWeight) || 700,
                    }, children: heading })), _jsx(Box, { sx: { display: 'flex', flexWrap: 'wrap', gap: 2 }, children: items.map((item, index) => (_jsx(Card, { sx: {
                            flex: '1 1 280px',
                            maxWidth: 400,
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(0,40,85,0.06)',
                            transition: 'box-shadow 0.3s ease, transform 0.25s ease, border-color 0.2s ease',
                            border: '1px solid',
                            borderColor: 'divider',
                            '&:hover': {
                                boxShadow: '0 8px 24px rgba(0,40,85,0.12)',
                                transform: 'translateY(-4px)',
                                borderColor: 'primary.main',
                            },
                        }, children: _jsxs(CardContent, { sx: { p: 3 }, children: [_jsx(Typography, { variant: "h6", sx: {
                                        mb: 1,
                                        fontFamily: fontFamily || undefined,
                                        fontWeight: Number(fontWeight) || 700,
                                        color: 'primary.dark',
                                    }, children: item.title }), item.description && (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: item.description })), _jsx(Button, { component: "a", href: item.linkHref, variant: "contained", color: "primary", size: "medium", sx: { fontWeight: 600 }, children: item.linkText })] }) }, index))) })] }) }));
};
export default CategoryCards;
